/** ----------- */
const GENERAL_INFORMATION = 'general_information';
const GENERAL_INFORMATION_PROPERTIES = [
    'categoryId',
    'createdByUserId',
    'metadataDocumentParties',
    'metadataDocumentProjectIds',
    'metadataDocumentIsSharedExternally',
    'metadataDocumentContractOwner',
    'metadataDocumentCountry',
    'metadataDocumentDocumentCategory',
    'metadataDocumentDocumentType',
    'metadataDocumentMaterialAgreement',
    'metadataDocumentOriginalVersionStored',
];
/** ----------- */
const LIFECYCLE_AND_STATUS = 'lifecycle_and_status';
const LIFECYCLE_AND_STATUS_PROPERTIES = [
    'metadataDocumentActive',
    'metadataDocumentStatus',
    'metadataDocumentEsigningStatus',
];
/** ----------- */
const DATES = 'dates';
const DATES_PROPERTIES = [
    'createdAt',
    'updatedAt',
    'metadataDocumentDateSigned',
    'metadataDocumentNoticeDate',
    'metadataDocumentProbationaryPeriodExpirationDate',
    'metadataDocumentStartDate',
    'metadataDocumentTerminationDate',
];
/** ----------- */
const COMMERCIAL = 'commercial';
const COMMERCIAL_PROPERTIES = [
    'metadataDocumentCurrency',
    'metadataDocumentDiscount',
    'metadataDocumentFeeAdjustmentClause',
    'metadataDocumentPaymentTermsDaysFromInvoiceDate',
    'metadataDocumentTotalContractCost',
    'metadataDocumentTotalContractValue',
];
/** ----------- */
const RENEWAL_AND_TERMINATION = 'renewal_and_termination';
const RENEWAL_AND_TERMINATION_PROPERTIES = [
    'metadataDocumentAutomaticRenewal',
    'metadataDocumentNoticePeriodDays',
    'metadataDocumentNoticePeriodMonths',
    'metadataDocumentOriginalTermMonths',
    'metadataDocumentPostTerminationObligations',
    'metadataDocumentRenewalTermMonths',
    'metadataDocumentTerminationForCause',
    'metadataDocumentTerminationForConvenience',
];
/** ----------- */
const LIABILITY_AND_RISK = 'liability_and_risk';
const LIABILITY_AND_RISK_PROPERTIES = [
    'metadataDocumentIndemnity',
    'metadataDocumentLiabilityCap',
    'metadataDocumentLiabilityCapScope',
    'metadataDocumentLimitationOfLiability',
];
/** ----------- */
const HR = 'hr';
const HR_PROPERTIES = ['metadataDocumentProbationaryPeriod'];
/** ----------- */
const REGULATORY = 'regulatory';
const REGULATORY_PROPERTIES = [
    'metadataDocumentDeviateFromStandard',
    'metadataDocumentGoverningLaw',
    'metadataDocumentOutsourcing',
    'metadataDocumentProcessingOfPersonalData',
];
/** ----------- */
const ACCESS = 'access';
const ACCESS_PROPERTIES = ['allowedTeams', 'allowedUsers'];
export const DOCUMENT_METADATA_GROUPS = {
    [GENERAL_INFORMATION]: GENERAL_INFORMATION_PROPERTIES,
    [LIFECYCLE_AND_STATUS]: LIFECYCLE_AND_STATUS_PROPERTIES,
    [DATES]: DATES_PROPERTIES,
    [COMMERCIAL]: COMMERCIAL_PROPERTIES,
    [RENEWAL_AND_TERMINATION]: RENEWAL_AND_TERMINATION_PROPERTIES,
    [LIABILITY_AND_RISK]: LIABILITY_AND_RISK_PROPERTIES,
    [HR]: HR_PROPERTIES,
    [REGULATORY]: REGULATORY_PROPERTIES,
    [ACCESS]: ACCESS_PROPERTIES,
};
export const DOCUMENT_METADATA_GROUP_KEYS = {
    GENERAL_INFORMATION,
    LIFECYCLE_AND_STATUS,
    DATES,
    COMMERCIAL,
    RENEWAL_AND_TERMINATION,
    LIABILITY_AND_RISK,
    HR,
    REGULATORY,
    ACCESS,
};
/** ----------- */
const CLAUSES_AND_TERMS = 'clauses_and_terms';
const CLAUSES_AND_TERMS_GROUPS = [
    COMMERCIAL,
    RENEWAL_AND_TERMINATION,
    LIABILITY_AND_RISK,
    HR,
    REGULATORY,
];
/** ----------- */
export const DOCUMENT_METADATA_NESTED_GROUPS = {
    [CLAUSES_AND_TERMS]: CLAUSES_AND_TERMS_GROUPS,
};
export const DOCUMENT_METADATA_NESTED_GROUP_KEYS = {
    CLAUSES_AND_TERMS,
};
